/** Onglets du détail d'un rôle : résumé (permissions) et titulaires (affectations). */
export const ROLE_TABS = ['summary', 'holders'] as const;
export type RoleTab = (typeof ROLE_TABS)[number];

export const isRoleTab = (value: unknown): value is RoleTab =>
  typeof value === 'string' && (ROLE_TABS as readonly string[]).includes(value);
